export default "__VITE_ASSET__CH0dxZps__"